import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { GameService } from '../../../../shared/services/game.service';
import { MessageService } from '../../../../shared/services/message.service';

import { UrlConstants } from '../../../../shared/constants/urlparams.constants';
import { StorageConstants } from '../../../../shared/constants/storage.constants';

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss']
})
export class GameComponent implements OnInit, OnDestroy {
  private gameName: string;

  constructor(private router: Router, private route: ActivatedRoute, private gameService: GameService, private messageService: MessageService) { }

  async ngOnInit() {
    await this.gameService.joinGame(localStorage.getItem(StorageConstants.PlayerName)).catch((error: any) => {
      if (error["status"] == 403) {
        this.messageService.showWarning("Het spel zit vol, u kunt niet mee spelen");
      }
      else {
        this.messageService.showError("Er is iets verkeerds gegaan bij het meedoen met het spel, herlaad de pagina en probeer het opnieuw");
      }
      
      this.router.navigateByUrl("/");
    });

    this.gameName = atob(decodeURI(this.route.snapshot.paramMap.get(UrlConstants.GameName)));
  }

  ngOnDestroy(): void {
    this.gameService.disconnect();
  }

  async startRound() {
    await this.gameService.startRound().catch(() => {
      this.messageService.showError("Er is iets fout gegaan bij het starten van een nieuwe ronde, herlaad de pagina en probeer het opnieuw");
    });
  }
}
